import Switcher from '../components/Switcher';
export default Switcher;
